/**
  * 判断是否为手机号码
 * @param {*} 只要是13,14,15,16,17,18,19开头即可
 * @returns Boolean
 */
export function isPoneAvailable (pone) {
  console.log('isPoneAvailable', pone)
  const myreg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
  if (!myreg.test(pone)) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/tools.js